import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {intlShape, injectIntl} from 'react-intl';
import {CategoryMetadata} from '../components/Metadata';
import {fetchAppsIfNeeded, fetchAppsIfNeededNextPage} from '../actions/apps-by-category';
import {openCategory, fetchHomeCategoriesIfNeeded} from '../actions/categories';
import {getCategoryData} from '../services/category-transformer';
import AppBox from '../components/App-box';
import ErrorMessage from '../components/Error-message';

const categoryTitle = category => {
  return (category.smallText && category.bigText) ? `${category.smallText} ${category.bigText}` : category.name;
};

const buildHeaderBackground = category => {
  const properties = {};
  if (category.headerColor) {
    properties.backgroundColor = category.headerColor;
  }
  if (category.headerImage) {
    properties.backgroundImage = `url('${category.headerImage}')`;
  }
  return properties;
};


// TODO remove CategoryContainer just use Category, remove injectIntl when merge RedirectToOneAppMarket
class CategoryContainer extends React.Component {
  static fetchData(dispatch, params, location) {
    const category = params.category;
    return Promise.all([
      dispatch(openCategory(category)),
      dispatch(fetchAppsIfNeeded(category, location.query.page)),
      dispatch(fetchHomeCategoriesIfNeeded())
    ]);
  }

  /**
   * Called from Layout component
   */
  static onScroll(scrolled, dispatch, params, location) {
    if (scrolled > 0.7) {
      dispatch(fetchAppsIfNeededNextPage(params.category, location.query.page));
    }
  }

  render() {
    return <CategoryWithIntl {...this.props}/>;
  }
}

function mapStateToProps(state, props) {
  const pathname = props.params.category;
  const categories = state.categories;
  const {items, isFetching} = state.appsByCategory[pathname] || {items: [], isFetching: true};
  const reviews = state.reviews.all;

  return {pathname, categories, items, isFetching, reviews};
}

export default connect(mapStateToProps)(CategoryContainer);



class Category extends React.Component {

  static propTypes = {
    pathname: PropTypes.string,
    categories: PropTypes.object,
    items: PropTypes.array.isRequired,
    reviews: PropTypes.object,
    isFetching: PropTypes.bool,
    params: PropTypes.object,
    dispatch: PropTypes.func,
    location: PropTypes.object,
    intl: intlShape
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.params.category !== nextProps.params.category) {
      CategoryContainer.fetchData(this.props.dispatch, nextProps.params, this.props.location);
    }
  }

  render() {
    const category = getCategoryData(this.props.categories, this.props.pathname, this.props.intl.formatMessage);
    const error = !this.props.items.length && !this.props.isFetching;

    return (
      <div className={classNames('page-category', category.slug)}>
        {this.props.isFetching ? <div className="circle-loader"></div> : null}
        <div className="top-bar-shadow"></div>

        {error ?
          <ErrorMessage/> :
          <div>
            <div className="category-header-container">
              <div className="category-header" style={buildHeaderBackground(category)}>
                <h2 className="category-title">{categoryTitle(category)}</h2>
                <p className="category-description">{category.hover}</p>
              </div>
            </div>

            <div className="app-box-grid section section-pad-left">
              {this.props.items.map((app, i) =>
                <AppBox key={app.slug} biPosition={i + 1} app={app} reviews={this.props.reviews}/>
              )}
            </div>

            <CategoryMetadata title={category.name} description={category.description} location={this.props.location} appCount={this.props.items.length}/>
          </div>
        }
      </div>
    );
  }
}

const CategoryWithIntl = injectIntl(Category);



// WEBPACK FOOTER //
// ./containers/Category.js